import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Page404 from './404';
// import { Homepage } from 'components/homepage';

// Import only constants directly to avoid pulling in entire modules
import { name as programName } from './program/config/constants';
import { testPolicyName, policyName, bdxName } from './policy/config/constants';
import { name as adminName } from './administration/config/constants';
import { name as billingName } from './billing/config/constants';
import LoadingPage from './loadingPage';
// import { AuthGuard } from '../auth';
import { userPermissions } from 'constants/userPermissions';
import { AuthGuard } from '@archre2/react-core';

// Lazy load heavy modules for code splitting
const ProgramIndex = lazy(() =>
  import('./program').then((module) => ({ default: module.ProgramIndex }))
);
const PolicyIndex = lazy(() =>
  import('./policy').then((module) => ({ default: module.PolicyIndex }))
);
const BdxIndex = lazy(() =>
  import('./policy/bdx').then((module) => ({ default: module.BdxIndex }))
);
const AdminIndex = lazy(() =>
  import('./administration').then((module) => ({ default: module.AdminIndex }))
);
const BillingIndex = lazy(() =>
  import('./billing').then((module) => ({ default: module.BillingIndex }))
);
const DashboardPage = lazy(() =>
  import('./dashboard').then((module) => ({ default: module.DashboardPage }))
);
const LogsPage = lazy(() => import('./logs'));
const TestPage = lazy(() => import('./test'));
const ReportIndex = lazy(() => import('./reports/pages'));
const UserIndex = lazy(() => import('./user'));
const WorkflowIndex = lazy(() =>
  import('modules/workflow').then((module) => ({
    default: module.WorkflowIndex,
  }))
);
const ToolsIndex = lazy(() => import('./tools'));
const BoundBookIndex = lazy(() =>
  import('./program/components/program/boundBook/BoundBookIndex')
);

const LoggingPage = () => <LogsPage className="grid-col-1-3" />;
const routes = [
  {
    component: ProgramIndex,
    path: `/${programName}/*`,
    rule: 'admin',
  },
  { component: DashboardPage, path: '/*', rule: 'admin', exact: true },
  { component: LoggingPage, path: '/logs/*', rule: 'admin' },
  { component: TestPage, path: '/test/*', rule: 'admin' },
  { component: ReportIndex, path: '/Reports/*', rule: 'admin' },
  { component: UserIndex, path: '/user/*', rule: 'admin' },
  {
    component: AdminIndex,
    path: `/${adminName}/*`,
    perform: userPermissions.MANAGE_SPA, // if user has lst permission then the route will load else would display 401
    rule: 'admin',
  },
  {
    component: BillingIndex,
    path: `/${billingName}/*`,
    perform: userPermissions.LIST_PROGRAM,
    rule: 'admin',
  },
  {
    component: ToolsIndex,
    path: `/Tools/*`,
    perform: userPermissions.LIST_TOOLS,
    rule: 'admin',
  },
  {
    component: PolicyIndex,
    path: `/${policyName}/*`,
    rule: 'admin',
  },
  {
    component: PolicyIndex,
    path: `/${testPolicyName}/*`,
    rule: 'admin',
  },
  {
    component: BdxIndex,
    path: `/${bdxName}/*`,
    rule: 'admin',
  },
  {
    component: BoundBookIndex,
    path: `/BoundBook/*`,
    rule: 'admin',
  },
  {
    path: `/Workflow/*`,
    name: 'Workflow',
    text: 'Workflow',
    component: WorkflowIndex,
    visible: false,
  },
  { component: DashboardPage, path: '/*', rule: 'admin', exact: true },
  { component: LoadingPage, path: '/callback/*', rule: 'admin' },
  { component: LoadingPage, path: '/logout', rule: 'admin' },
];

export default function Router() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <Routes>
        {routes.map((r, i) => (
          <Route key={i} path={r.path} element={<AuthGuard {...r} />} />
        ))}
        <Route path="*" element={<AuthGuard path="*" component={Page404} />} />
      </Routes>
    </Suspense>
  );
}
